var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.98152 8.80891C0.449911 9.39297 -0.357677 8.5057 0.173933 7.92164L4.22295 3.47312C4.39783 3.28099 4.65754 3.2395 4.86903 3.34865L8.74596 4.88444L12.0495 1.25494H10.5088C9.75696 1.25494 9.75696 0 10.5088 0H13.4289C13.7444 0 14 0.280869 14 0.627462V3.83569C14 4.66168 12.8578 4.66168 12.8578 3.83569V2.14227L9.29971 6.05137L9.29797 6.04946C9.14692 6.21478 8.91742 6.2799 8.70361 6.19563L4.77611 4.64005L0.98152 8.80891Z",
    fill: "#394150"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopular);
export default __webpack_public_path__ + "static/media/Popular.24525c1a6ed83a13118108852177973c.svg";
export { ForwardRef as ReactComponent };